// extracted by mini-css-extract-plugin
module.exports = {"small":"Typography_small__rgzUA"};